import React, { memo } from 'react';

import styles from './UserQuestion.module.less';

export default memo(({ question }) => {
  return (
    <div className={styles.user_question}>
      <div className="question_info">{question}</div>
    </div>
  );
});
